import React, { FC } from 'react';
import { isMobile } from 'is-mobile';

import { IFilterRule } from '../../../../redux/filters/filter.duck.interface';
import FilterButton from '@components/FilterButton';
import { HandledComponentError } from '@components/ErrorHandling';
import { BrandTypes } from '../../../../types/brands';
import { BRAND } from '../../../../constants/main';
import Icon, { Icons } from '../../../Icon';
import useTranslations from '@hooks/useTranslations';
import { getFilterButtonId } from '../../utils';

interface ButtonsGroupProps {
    groupType: 'gearbox' | 'fuel';
    data: IFilterRule[];
    handleChange: (name: string, value: boolean) => void;
}

const ButtonsGroup: FC<ButtonsGroupProps> = React.memo(({ data, groupType, handleChange }) => {
    const { t } = useTranslations();

    try {
        return (
            <div className={`filter-grid__${groupType}`} data-testid={`TESTING_FILTER_${groupType}`}>
                {data.map((dataField) => (
                    <FilterButton
                        className={`grid-button ${(dataField.value as boolean) ? 'active' : ''}`}
                        key={dataField.name}
                        id={getFilterButtonId(dataField.name)}
                        active={dataField.value as boolean}
                        disabled={dataField.disabled}
                        onClick={() => {
                            handleChange(dataField.name, !dataField.value);
                        }}
                        isMobile={isMobile()}
                    >
                        <div className="disp-inline">
                            {t(dataField.displayName)}

                            {[BrandTypes.DS, BrandTypes.AP, BrandTypes.AC].includes(BRAND as BrandTypes) &&
                                dataField.value && <Icon className="info-check" name={Icons.Check} />}
                        </div>
                    </FilterButton>
                ))}
            </div>
        );
    } catch (e: any) {
        return <HandledComponentError error={e} />;
    }
});

ButtonsGroup.displayName = 'ButtonsGroup';
export default ButtonsGroup;
